function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { ThemeProvider } from "@rmwc/theme";
import * as React from "react";
import { createTheme } from "@kaggle/core";
export var MaterialThemeProvider = function(props) {
    var theme = createTheme();
    var kaggleDefaults = {
        primary: theme.km.color.kaggle.blue,
        error: theme.km.color.status.error,
        background: theme.legacyColors.brand.grey[50],
        surface: theme.km.color.kaggle.white,
        primaryBg: theme.km.color.kaggle.blue,
        secondaryBg: theme.legacyColors.brand.grey[500],
        onPrimary: theme.km.color.kaggle.white
    };
    var options = _objectSpread({}, kaggleDefaults, props.options);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        options: options,
        wrap: props.wrap,
        style: props.style
    }, props.children);
};
